import styled, { css } from 'styled-components';
import { space } from 'styled-system';
export const SystemIconBase = styled.i `
  line-height: inherit;
  font-size: inherit;
  color: inherit;
  flex-shrink: 0;
  white-space: nowrap;

  ${space}

  ${({ color }) => color &&
    css `
      color: var(--color-${String(color)});
    `}

  ${({ size }) => css `
    width: ${size}px;
    font-size: ${size}px;
    line-height: ${size}px;
  `}
`;
